import { Component, ViewChild } from '@angular/core'
import { PdfChart } from '../../shared/pdfChart'
import { MarketCapRankPeComponent } from '../market-cap-rank-pe/market-cap-rank-pe.component'
import { MarketCapRankTopSecurityComponent } from '../market-cap-rank-top-security/market-cap-rank-top-security.component'
import { CpmService } from '../../service/cpm.service';
import { environment } from '../../../environments/environment';
import { ExportExcelService } from '../../service/export-excel.service';
@Component({
  selector: 'app-market-cap-rank',
  templateUrl: './market-cap-rank.component.html',
  styleUrls: ['./market-cap-rank.component.scss']
})
export class MarketCapRankComponent {
  strName
  listMarketP
  year
  list
  ytdValue = 0
  pdfChart: PdfChart = new PdfChart()
  dataProviderYTD

  @ViewChild(MarketCapRankPeComponent)
  marketCapRankPeComponent: MarketCapRankPeComponent
  @ViewChild(MarketCapRankTopSecurityComponent)
  marketCapRankTopSecurityComponent: MarketCapRankTopSecurityComponent

  constructor(
    private cpmService: CpmService,
    private excelService: ExportExcelService
  ) { }

  exportFunctionsCapRank() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailCapRank(
        this.cpmService
      )
    );

    arrayOfFunctions.set(
      'print',
      this.exportPrintCapRank()
    );

    arrayOfFunctions.set(
      'pdf',
      this.exportPdfCapRank()
    );

    arrayOfFunctions.set(
      'excel',
      this.exportExcelCapRank(
        this.marketCapRankPeComponent
      )
    );

    return arrayOfFunctions;
  }

  exportEmailCapRank(service) {
    return function mailCapRank() {
      service.saveMarketCapPeRankPdfFile().then(filename => {
        const subject = 'ASEAN Exchanges: Market cap (mil.USD) and PE ratio';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  }

  exportPrintCapRank = function () {
    return function CapRankPrint() {
      const popupWin = window.open(
        `/#/marketCapPeRank/`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };

  exportPdfCapRank = function () {
    const service = this.cpmService;
    return function TopIpoPdf() {
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/marketCapPeRank`
      );
    };
  };

  exportExcelCapRank(marketCapRankPeComponent) {
    return function excelTopIpo() {
      marketCapRankPeComponent.excel()
    };
  };

  exportFunctionsCapRankTop() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailCapRankTop(
        this.marketCapRankTopSecurityComponent
      )
    );

    arrayOfFunctions.set(
      'print',
      this.exportPrintCapRankTop(
        this.marketCapRankTopSecurityComponent
      )
    );

    arrayOfFunctions.set(
      'pdf',
      this.exportPdfCapRankTop(
        this.marketCapRankTopSecurityComponent
      )
    );

    arrayOfFunctions.set(
      'excel',
      this.exportExcelCapRankTop(
        this.marketCapRankTopSecurityComponent
      )
    );

    return arrayOfFunctions;
  }


  exportEmailCapRankTop(marketCapRankTopSecurityComponent) {
    return function mailCapRankTop() {
      marketCapRankTopSecurityComponent.mail()
    };
  }

  exportPrintCapRankTop = function (marketCapRankTopSecurityComponent) {
    return function CapRankTopPrint() {
      const checkedIds = marketCapRankTopSecurityComponent.getCheckedId()
      const popupWin = window.open(
        `/#/marketCapSecurityRank/${marketCapRankTopSecurityComponent.topRank}/${checkedIds.join()}`,
        '_blank',
        'width=850px,height=1024px'
      );
    }
  };

  exportPdfCapRankTop = function (marketCapRankTopSecurityComponent) {
    const service = this.cpmService;
    return function CapTopIpoPdf() {
      marketCapRankTopSecurityComponent.pdf()
    };
  };

  exportExcelCapRankTop(marketCapRankTopSecurityComponent) {
    return function excelCapTopIpo() {
      marketCapRankTopSecurityComponent.excel()
    };
  };


  marketCapPEmail() {
    this.marketCapRankPeComponent.mail()
  }

  marketCapPEprint() {
    this.marketCapRankPeComponent.print()
  }

  marketCapPEpdf() {
    this.marketCapRankPeComponent.pdf()
  }

  marketCapPEexcel() {
    this.marketCapRankPeComponent.excel()
  }

  topSecuritymail() {
    this.marketCapRankTopSecurityComponent.mail()
  }

  topSecurityprint() {
    this.marketCapRankTopSecurityComponent.print()
  }

  topSecuritypdf() {
    this.marketCapRankTopSecurityComponent.pdf()
  }

  topSecurityexcel() {
    this.marketCapRankTopSecurityComponent.excel()
  }



}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-cap-rank/market-cap-rank.component.ts